@use "src/components/docs/inlineReference";

.link[data-page-link-breadcrumb] {
  @include inlineReference.reference;
  flex-wrap: wrap;
  border: 0;
  border-radius: 0;
  padding: 0;
  background: transparent;
  font-size: inherit;
  color: var(--color-primary);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
  text-decoration-color: color-mix(in srgb, currentColor 35%, transparent);
  overflow-wrap: anywhere;
  transition: background 120ms ease, border-color 120ms ease;

  &:hover {
    color: var(--color-action-hover);
    text-decoration-color: currentColor;
    background: transparent;
  }

  > span {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
}

// A plain docs link: the same primary underline as a reference, without the chip layout.
.link:not([data-page-link-breadcrumb]) {
  color: var(--color-primary);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
  text-decoration-color: color-mix(in srgb, currentColor 35%, transparent);
  overflow-wrap: anywhere;

  &:hover {
    color: var(--color-action-hover);
    text-decoration-color: currentColor;
  }
}

.step {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  min-width: 0;

  svg {
    width: 0.7em;
    height: 0.7em;
    color: var(--color-muted);
  }
}

.icon {
  display: inline-flex;
  align-items: center;
  color: var(--color-muted);
}
